export default __webpack_public_path__ + "static/media/x33-movie-icon.b9409b1e.svg";